<ion-button (click)="openModal()" fill="clear" shape="round">
  <ion-icon aria-hidden="true" class="padding-right-s" name="add-circle"></ion-icon>Add subject
</ion-button>
